var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{on:{"ready":function($event){return _vm.$emit('ready', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }